import React, { useContext, useEffect, useState } from 'react';
import './App.css';
import { Outlet } from 'react-router-dom';
import LoadingScreen from './components/loadingScreenComp/LoadingScreen';
import Header from './components/headerComp/Header';
import UserMenu from './components/headerComp/UserMenu';
import ThemeSelectMenu from './components/headerComp/ThemeSelectMenu';
import { useTheme } from './context/ThemeContext';
import SideMenuNew from './components/sideMenu/SideMenuNew';
import { useRunMode } from './context/RunModeContext';
import NotifyIconMenu from './components/headerComp/NotifyIconMenu';

const App = () => {
    //const {alert, setAlert} = useContext(AlertContext)
    
    // Theme context
    const {theme, setTheme} = useTheme()
    // Side menu status
    const [isSideMenuStatus, setIsSideMenuStatus] = useState<boolean>(true)
    // Loading status
    const [isLoading, setIsLoading] = useState<boolean>(false)

    // User menu status
    const [userMenuStatus, setUserMenuStatus] = useState<boolean>(false)
    // Header theme select menu status
    const [headerThemeMenuStatus, setHeaderThemeMenuStatus] = useState<boolean>(false)

    const [notifyMenuStatus, setNotifyMenuStatus] = useState<boolean>(false)

    // Schedule Auto Logout when token expired
//     useEffect(() => {
//     //console.log("checked");
//     scheduleAutoLogout();

//     const interval = setInterval(() => {
//       console.log("Rechecking token...");
//       scheduleAutoLogout();
//     }, 1 * 60 * 1000); // 1min

//     return () => clearInterval(interval); // Cleanup on unmount
//   }, []);

    useEffect(() => {
        if(userMenuStatus){
            setHeaderThemeMenuStatus(false)
        }
    }, [userMenuStatus])

    useEffect(() => {
        if(headerThemeMenuStatus){
            setUserMenuStatus(false)
        }
    }, [headerThemeMenuStatus])

    // Get refresh token
    /* const getRefreshToken = () => {
        const intervals = setInterval(async () => {
            getRefreshToken()
        }, 10 * 60 * 1000)

        return () => clearInterval(intervals)
    }

    useEffect(() => {
        setIsLoading(true)
        // Get new access token
        getRefreshToken()
        
        //getRefreshToken()
        setIsLoading(false)
    }, []) */

    const { mode } = useRunMode()

    return (
        <div className={`App ${theme}`}>
            
            <Header sideMenuStatus={setIsSideMenuStatus} userMenuStatus={setUserMenuStatus} themeMenuStatus={setHeaderThemeMenuStatus} notifyMenuStatus={setNotifyMenuStatus}/>
            
            <div className={`data-wrapper`}>
                {/* <SideMenu isMenuOpen={isSideMenuStatus} setIsMenuOpen={setIsSideMenuStatus}/> */}
                <SideMenuNew isMenuOpen={isSideMenuStatus} setIsMenuOpen={setIsSideMenuStatus}/>
                <div className={`body-wrapper`}>
                    {mode === 'TEST' && (
                        <div className='mode-warning-wrapper'>
                            <span>You're currently in test mode. This environment is for testing only and may not reflect live behavior.</span>
                        </div>
                    )}
                    <Outlet />
                </div>
            </div>
            {userMenuStatus && (
                <UserMenu />
            )}
            {notifyMenuStatus && (
                <NotifyIconMenu />
            )}
            {headerThemeMenuStatus && (
                <ThemeSelectMenu setMenuStatus={setHeaderThemeMenuStatus}/>
            )}
            {/* Loading screen */}
            {isLoading && (
                <LoadingScreen />
            )}
        </div>
    );
}

export default App;
